



function StressedPersosnality(props) {

    const {
        label = "",
        selectValKey = "",
        selectVal = "",
        checkBoxValKey = "",
        checkBoxVal = false,
        handleChange,
        options = []

    } = props

    return (
        <div className="d-flex gap-2">
            <label className="custom-switch-wrap m-0">
                <div className="position-relative d-flex align-items-center">
                    <input
                        type="checkbox"
                        className="switch-input"
                        checked={checkBoxVal}
                        onChange={() => handleChange(checkBoxValKey, !checkBoxVal)}
                    />
                    <span className="switch-slider"></span>
                </div>
            </label>
        {/* <div className="d-flex gap-2 align-items-center" style={{ padding: '3px', backgroundColor: 'whitesmoke', borderRadius: '10px', border: '1px solid grey' }}>
            
            <span className="text-sm text-dark fw-bold" style={{ width: '100%' }}>{label}</span> */}
            <select
                className="form-select"
                style={{ width: '180px', minHeight: '20px' }}
                value={selectVal}
                onChange={(e) => handleChange(selectValKey, e.target.value)}
                disabled={!checkBoxVal}
            >
                <option value="" disabled>{label}</option>
                {
                    options.map((option, index) => (
                        <option key={index} value={option.value}>{option.label}</option>
                    ))
                }

            </select>

        {/* </div> */}
        </div>
    )

}

export default StressedPersosnality